/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  deleteManagementReportTemplate,
  downloadManagementTemplate,
  fetchManagementReportTemplate,
  uploadManagementReportTemplate
} from '../../lib/rest/managementReportTemplateAPIClient'
import FileTemplateManager from '../FileTemplateManager'
import { useQuery } from '@tanstack/react-query'
import { useSettingsContext } from '../SettingsProvider'

function ManagementReportTemplateField () {
  const intl = useIntl()
  const { settings } = useSettingsContext()

  const fileQuery = useQuery({
    enabled: true,
    queryKey: ['managementReportTemplate'],
    queryFn: () => fetchManagementReportTemplate()
  })

  return (
    <FileTemplateManager
      accept={settings.MANAGEMENT_REPORT_TEMPLATE_FILE_TYPES}
      maxSize={settings.MANAGEMENT_REPORT_TEMPLATE_MAX_UPLOAD_SIZE}
      loading={fileQuery.isLoading}
      label={intl.formatMessage({
        id: 'management_report_template',
        defaultMessage: 'Modèle de rapport de gérance'
      })}
      description={intl.formatMessage({
        id: 'management_report_template_help',
        defaultMessage: 'Ce modèle est utilisé pour la génération des rapports de gérance.'
      })}
      onChange={() => fileQuery.refetch()}
      onDelete={deleteManagementReportTemplate}
      onDownload={downloadManagementTemplate}
      onUpload={uploadManagementReportTemplate}
      value={fileQuery.data ? 'template.docx' : null}
      lastModified={fileQuery.data?.LastModified}
      contentLength={fileQuery.data?.ContentLength}
    />
  )
}

export default ManagementReportTemplateField
